import CirclePattern from "./CirclePattern";

export default function Lifecycle() {
  return (
    <section
      data-testid="lifecycle-section"
      className="relative py-10 bg-ecoh-ink text-ecoh-bg overflow-hidden"
    >
      {/* Decorative pattern — derived from ecoHeatwave Circle Pattern motif */}
      <CirclePattern
        className="pointer-events-none select-none absolute -right-24 -top-16 w-[120%] md:w-[80%] h-auto"
        opacity={0.18}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-8">
            <h2
              data-testid="lifecycle-headline"
              className="font-display text-4xl sm:text-5xl lg:text-7xl font-extralight tracking-[-0.02em] leading-[1.02]"
            >
              Lower complexity.
              <br />
              <span className="font-light text-ecoh-amber">Long-term confidence.</span>
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-white/70 text-base md:text-lg font-light leading-relaxed">
              No moving parts and no annual servicing requirements. Each system is
              supported by a 20-year manufacturer's warranty.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
